'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'
import {
  FiHome,
  FiUsers,
  FiAward,
  FiCreditCard,
  FiBarChart2,
  FiSettings,
  FiLogOut,
  FiActivity,
  FiHardDrive,
  FiDatabase,
  FiGlobe,
  FiServer,
  FiKey,
  FiLayers,
  FiSearch,
  FiRepeat,
  FiFileText,
  FiTarget,
  FiZap,
  FiShoppingBag,
  FiBox,
  FiTag,
  FiTruck,
  FiPieChart,
  FiMapPin,
  FiBriefcase,
  FiCheck,
  FiSend,
  FiSlash,
  FiArchive,
  FiRefreshCcw,
  FiPlus,
  FiMessageSquare,
  FiPackage,
  FiShoppingCart,
  FiChevronDown,
  FiChevronRight,
  FiMinus,
  FiStar
} from 'react-icons/fi'
import { useState, useEffect } from 'react'

export const adminMenuItems = [
  { href: '/dashboard', icon: FiHome, label: 'Dashboard' },
  { href: '/usuarios', icon: FiUsers, label: 'Usuarios' },
  { href: '/analitica', icon: FiActivity, label: 'Métricas & Analítica' },
  { href: '/planes', icon: FiAward, label: 'Planes' },
  { href: '/pagos', icon: FiCreditCard, label: 'Pagos' },
  { href: '/reportes', icon: FiBarChart2, label: 'Reportes' },
  { href: '/hosting', icon: FiServer, label: 'Hosting (WHM)' },
]

export const clientHostingMenuItems = [
  { href: '/hosting', icon: FiHome, label: 'Mi Hosting' },
  { href: '/hosting/plan', icon: FiAward, label: 'Mi Plan' },
  { href: '/hosting/files', icon: FiHardDrive, label: 'Archivos' },
  { href: '/hosting/databases', icon: FiDatabase, label: 'Base de Datos' },
]

export const miApiMenuItems = [
  {
    title: 'MIAPI REST CONFIGURACIÓN',
    items: [
      { href: '/resumen', icon: FiZap, label: 'Mi Resumen', badge: 'NUEVO' },
      { href: '/plan', icon: FiAward, label: 'Mi Plan' },
      { href: '/token', icon: FiKey, label: 'Mi Token' },
      { href: '/pagos', icon: FiCreditCard, label: 'Mis Pagos' },
      { href: '/empresas', icon: FiBriefcase, label: 'Registrar Empresas' },
    ]
  },
  {
    title: 'VALIDACIÓN DE INFORMACIÓN',
    items: [
      { href: '/validar/identidad', icon: FiSearch, label: 'Identificación' },
      { href: '/validar/tipo-cambio', icon: FiRepeat, label: 'Tipo de Cambio', badge: 'SUNAT' },
      { href: '/validar/xml-pdf', icon: FiFileText, label: 'Convertir XML a PDF', badge: 'SUNAT' },
      { href: '/validar/sunat', icon: FiSearch, label: 'Consultas SUNAT', badge: 'NUEVO' },
      { href: '/validar/masivo-dni', icon: FiUsers, label: 'Masivo DNI', badge: 'PRO' },
      { href: '/validar/masivo-ruc', icon: FiBriefcase, label: 'Masivo RUC', badge: 'PRO' },
      { href: '/whatsapp-api', icon: FiMessageSquare, label: 'API de WhatsApp', badge: 'NUEVO' },
    ]
  },
  {
    title: 'FACTURACIÓN ELECTRÓNICA',
    items: [
      { href: '/facturacion/comprobantes', icon: FiFileText, label: 'Generar XML Comprobantes' },
      { href: '/facturacion/nota-credito', icon: FiFileText, label: 'Generar XML Nota Crédito' },
      { href: '/facturacion/nota-debito', icon: FiFileText, label: 'Generar XML Nota Débito' },
      { href: '/facturacion/enviar', icon: FiSend, label: 'Envio a SUNAT' },
    ]
  },
  {
    title: 'SUNAT (GUÍAS DE REMISIÓN)',
    items: [
      { href: '/guias/token', icon: FiKey, label: 'Token y Ticket' },
      { href: '/guias/generar', icon: FiTruck, label: 'Generar XML GUIAS' },
      { href: '/guias/enviar', icon: FiSend, label: 'Envio GUIAS a SUNAT' },
    ]
  },
  {
    title: 'COMUNICACIÓN DE BAJAS',
    items: [
      { href: '/bajas/comprobantes', icon: FiSlash, label: 'Comprobantes (Bajas)' },
      { href: '/bajas/resumen', icon: FiArchive, label: 'Resumen de Boletas' },
    ]
  }
]

export const erpMenuItems = [
  {
    items: [
      { href: '/dashboard', icon: FiHome, label: 'Volver a MIAPI' },
      { href: '/erp', icon: FiPieChart, label: 'Dashboard' },
      {
        label: 'Ventas',
        icon: FiShoppingCart,
        subItems: [
          { href: '/erp/pos', label: 'Punto de Venta (POS)', badge: 'NUEVO' },
          { href: '/erp/ventas/nueva', label: 'Nueva Venta' },
          { href: '/erp/ventas/historial', label: 'Historial de Ventas' },
          { href: '/erp/clientes', label: 'Clientes' },
        ]
      },
      {
        label: 'Caja y Cobranzas',
        icon: FiCreditCard,
        subItems: [
          { href: '/erp/caja', label: 'Administrar Caja' },
          { href: '/erp/caja/historial', label: 'Historial de Cajas' },
          { href: '/erp/ventas/cxc', label: 'Cuentas por Cobrar' },
        ]
      },
      {
        label: 'Inventario',
        icon: FiBox,
        subItems: [
          { href: '/erp/productos', label: 'Productos' },
          { href: '/erp/categorias', label: 'Categorías' },
          { href: '/erp/almacen', label: 'Control de Stock' },
          { href: '/erp/inventario/transferencias', label: 'Transferencias', badge: 'PRO' },
          { href: '/erp/inventario/ajustes', label: 'Ajustes de Stock' },
          { href: '/erp/inventario/kardex', label: 'Movimientos (Kardex)' },
        ]
      },
      {
        label: 'Compras y Gastos',
        icon: FiShoppingBag,
        subItems: [
          { href: '/erp/compras/nueva', label: 'Nueva Compra', badge: 'NUEVO' },
          { href: '/erp/compras/historial', label: 'Historial de Compras' },
          { href: '/erp/proveedores', label: 'Proveedores' },
          { href: '/erp/compras/cxp', label: 'Cuentas por Pagar' },
          { href: '/erp/compras/abonos', label: 'Gestión de Pagos' },
          { href: '/erp/gastos', label: 'Registro de Gastos' },
        ]
      },
      {
        label: 'SUNAT / Facturación',
        icon: FiLayers,
        subItems: [
          { href: '/erp/series', label: 'Series y Correlativos' },
          { href: '/erp/sunat/tipos-comprobante', label: 'Tipos de Documento' },
          { href: '/erp/sunat/tipos-afectacion', label: 'Tipos de Afectación' },
          { href: '/erp/sunat/unidades-medida', label: 'Unidades de Medida' },
          { href: '/erp/sunat/metodos-pago', label: 'Métodos de Pago' },
          { href: '/erp/sunat/motivos-ajuste', label: 'Motivo del Ajuste' },
        ]
      },
      {
        label: 'SIRE / SUNAT',
        icon: FiDatabase,
        subItems: [
          { href: '/erp/sire/compras', label: 'Registro de Compras (RCE)' },
          { href: '/erp/sire/ventas', label: 'Registro de Ventas (RVIE)' },
          { href: '/erp/sire/tickets', label: 'Historial de Tickets' },
        ]
      },
      {
        label: 'Administración',
        icon: FiSettings,
        subItems: [
          { href: '/erp/configuracion-api', label: 'Configuración de API' },
          { href: '/erp/sucursales', label: 'Sucursales / Locales' },
          { href: '/erp/usuarios', label: 'Usuarios y Roles' },
        ]
      },
      {
        label: 'Reportes',
        icon: FiBarChart2,
        subItems: [
          { href: '/erp/reportes', label: 'Reportes de Gestión' },
        ]
      }
    ]
  }
]

export const crmMenuItems = [
  {
    items: [
      { href: '/empresas', icon: FiBriefcase, label: 'Volver a Empresas' },
      { href: '/crm', icon: FiActivity, label: 'Resumen CRM' },
      { href: '/crm/leads', icon: FiUsers, label: 'Leads' },
      { href: '/crm/conversaciones', icon: FiMessageSquare, label: 'Conversaciones' },
      { href: '/crm/embudo', icon: FiTarget, label: 'Embudo Comercial' },
      { href: '/crm/seguimientos', icon: FiCheck, label: 'Seguimientos' },
      { href: '/crm/campanas', icon: FiLayers, label: 'Campañas' },
      { href: '/crm/equipo', icon: FiUsers, label: 'Equipo Comercial' },
      { href: '/crm/configuracion', icon: FiSettings, label: 'Configuracion CRM' },
    ]
  }
]

function buildCrmMenuForUser(usuario: any) {
  const permissions = usuario?.crmPermissions || []
  const canViewLeads = permissions.includes('CRM_LEADS_VIEW_ALL') || permissions.includes('CRM_LEADS_VIEW_OWN')
  const canViewTasks = permissions.includes('CRM_TASKS_VIEW_ALL') || permissions.includes('CRM_TASKS_VIEW_OWN')
  const canViewCampaigns = permissions.includes('CRM_CAMPAIGNS_VIEW')
  const canViewTeam = permissions.includes('CRM_TEAM_VIEW') || permissions.includes('CRM_TEAM_MANAGE')
  const canManageConfig = permissions.includes('CRM_CONFIG_VIEW') || permissions.includes('CRM_CONFIG_MANAGE')

  const baseItems = crmMenuItems[0].items.filter((item) => {
    if (item.href === '/empresas' && usuario?.crmOnly) return false
    if (item.href === '/crm/leads') return canViewLeads
    if (item.href === '/crm/conversaciones') return canViewLeads
    if (item.href === '/crm/embudo') return canViewLeads
    if (item.href === '/crm/seguimientos') return canViewTasks
    if (item.href === '/crm/campanas') return canViewCampaigns
    if (item.href === '/crm/equipo') return canViewTeam
    if (item.href === '/crm/configuracion') return canManageConfig
    return true
  })

  return [{ items: baseItems }]
}

export default function Sidebar() {
  const pathname = usePathname() || ''
  const [usuario, setUsuario] = useState<{ isAdmin?: boolean; isHostingUser?: boolean; hostingAccounts?: any[]; selectedSucursalId?: number; selectedPeriodo?: string; empresaNombre?: string; sucursalNombre?: string; planPersonalizado?: number; crmPermissions?: string[]; crmOnly?: boolean } | null>(null)
  const [openMenus, setOpenMenus] = useState<Record<string, boolean>>({})

  const [sucursales, setSucursales] = useState<any[]>([])
  const [periodos, setPeriodos] = useState<any[]>([])
  const [loadingContext, setLoadingContext] = useState(false)

  const toggleMenu = (label: string) => {
    setOpenMenus(prev => ({ ...prev, [label]: !prev[label] }))
  }

  useEffect(() => {
    fetch('/api/auth/verificar')
      .then(res => res.json())
      .then(data => {
        if (data.success) setUsuario(data.usuario)
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (pathname.startsWith('/erp') && usuario) {
      // Cargar sucursales
      fetch('/api/erp/sucursales')
        .then(res => res.json())
        .then(data => { if (data.success) setSucursales(data.data) })
      
      // Cargar periodos
      fetch('/api/erp/periodos')
        .then(res => res.json())
        .then(data => { 
          if (data.success) {
            setPeriodos(data.data) 
            // Si no hay periodos, crear el actual por defecto
            if (data.data.length === 0) {
                const now = new Date()
                const nombre = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
                fetch('/api/erp/periodos', {
                    method: 'POST',
                    body: JSON.stringify({ nombre })
                }).then(r => r.json()).then(d => { if (d.success) setPeriodos([d.data]) })
            }
          }
        })
    }
  }, [usuario, pathname])

  const handleSessionUpdate = async (updates: { sucursalId?: number, sucursalNombre?: string, periodo?: string, periodoId?: number }) => {
    setLoadingContext(true)
    try {
      const res = await fetch('/api/erp/session/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      })
      const data = await res.json()
      if (data.success) {
        window.location.reload()
      }
    } catch (e) {
      console.error(e)
    } finally {
      setLoadingContext(false)
    }
  }

  const handleLogout = async () => {
    try {
      await fetch('/api/auth/logout', { method: 'POST' })
      window.location.href = '/login'
    } catch (error) {
      console.error('Error al cerrar sesión', error)
    }
  }

  // Decidir qué menú mostrar
  const [items, setItems] = useState<any[]>([])

  useEffect(() => {
    if (usuario) {
      if (usuario.isAdmin) {
        if (pathname.startsWith('/erp')) {
          const erpAdmin = erpMenuItems.map(section => ({
            ...section,
            items: section.items.map(item => 
              item.label === 'Volver a MIAPI' 
                ? { ...item, href: '/dashboard', label: 'Volver a MIAPI.Cloud' } 
                : item
              )
          }))
          setItems(erpAdmin)
        } else if (pathname.startsWith('/crm')) {
          setItems(buildCrmMenuForUser(usuario))
        } else {
          setItems([{ items: adminMenuItems }])
        }
      } else if (usuario.isHostingUser) {
        setItems([{ title: 'MI HOSTING', items: clientHostingMenuItems }])
      } else {
        if (pathname.startsWith('/erp')) {
          if (!(usuario as any).hasDashboard) {
            const erpFiltered = erpMenuItems.map(section => ({
              ...section,
              items: section.items.filter(item => item.label !== 'Volver a MIAPI')
            }))
            setItems(erpFiltered)
          } else {
            setItems(erpMenuItems)
          }
        } else if (pathname.startsWith('/crm')) {
          setItems(buildCrmMenuForUser(usuario))
        } else {
          if (!(usuario as any).hasDashboard && (usuario as any).hasErp) {
            window.location.href = '/erp'
            return
          }

          if (!(usuario as any).hasDashboard && (usuario as any).hasCrm) {
            window.location.href = '/crm'
            return
          }

          let apiItems = miApiMenuItems

          // Filtrar elementos para Plan Gratuito (Precio 0)
          if ((usuario as any).planPrecio === 0 || (usuario as any).plan === 'Plan Gratuito' || (usuario as any).planNombre === 'Plan Gratuito') {
            apiItems = miApiMenuItems.filter(section => 
              section.title === 'MIAPI REST CONFIGURACIÓN' || 
              section.title === 'VALIDACIÓN DE INFORMACIÓN'
            )
          }

          // Filtrar elementos para Plan Personalizado (Solo para usuarios no-admin)
          if (!usuario.isAdmin && usuario.planPersonalizado !== 1) {
            apiItems = apiItems.map(section => ({
              ...section,
              items: section.items.filter(item => 
                item.label !== 'Masivo DNI' && item.label !== 'Masivo RUC'
              )
            }))
          }

          setItems(apiItems)
        }
      }
    }
  }, [usuario, pathname])

  useEffect(() => {
    setOpenMenus((prev) => {
      const next = { ...prev }
      let changed = false

      items.forEach((section) => {
        section.items.forEach((item: any) => {
          if (item.subItems?.some((sub: any) => pathname === sub.href) && !next[item.label]) {
            next[item.label] = true
            changed = true
          }
        })
      })

      return changed ? next : prev
    })
  }, [items, pathname])

  return (
    <aside className="hidden lg:flex fixed left-0 top-0 z-40 h-screen w-64 flex-col border-r bg-white">
      <div className="flex-shrink-0 flex h-16 items-center border-b px-6 bg-white z-10 sticky top-0">
        <div className="flex items-center gap-2 font-bold text-xl text-primary">
          <FiActivity className="h-6 w-6" />
          <span>{usuario?.isAdmin ? 'MiApi.Cloud' : 'Mi Panel'}</span>
        </div>
      </div>

      {pathname.startsWith('/erp') && usuario?.empresaNombre && (
        <div className="px-6 py-4 bg-emerald-50/50 border-b space-y-3 animate-in slide-in-from-left duration-300">
           <div className="space-y-0.5">
             <p className="text-[9px] font-bold text-emerald-600 uppercase tracking-widest">Empresa</p>
             <p className="text-sm font-bold text-gray-800 truncate">{usuario.empresaNombre}</p>
           </div>
           
           <div className="space-y-3">
             <div className="space-y-1">
               <p className="text-[9px] font-bold text-emerald-600 uppercase tracking-widest leading-none">Sucursal</p>
               <div className="relative group">
                 <FiMapPin className="absolute left-2 top-1/2 -translate-y-1/2 h-3 w-3 text-emerald-500 z-10" />
                 <select 
                   className="w-full bg-white border border-emerald-100 rounded-lg pl-7 pr-2 py-1.5 text-xs text-gray-700 outline-none focus:ring-2 focus:ring-emerald-500/20 appearance-none cursor-pointer transition-all hover:border-emerald-300 font-medium"
                   disabled={loadingContext}
                   value={usuario.selectedSucursalId || ''}
                   onChange={(e) => {
                     const id = parseInt(e.target.value)
                     const name = sucursales.find(s => s.id === id)?.nombre
                     handleSessionUpdate({ sucursalId: id, sucursalNombre: name })
                   }}
                 >
                   {sucursales.map(s => (
                     <option key={s.id} value={s.id}>{s.nombre}</option>
                   ))}
                 </select>
                 <FiChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400 pointer-events-none" />
               </div>
             </div>

             <div className="space-y-1">
                <p className="text-[9px] font-bold text-emerald-600 uppercase tracking-widest leading-none">Periodo Maestro</p>
                <div className="relative group">
                  <FiPieChart className="absolute left-2 top-1/2 -translate-y-1/2 h-3 w-3 text-amber-500 z-10" />
                  <select 
                    className="w-full bg-white border border-emerald-100 rounded-lg pl-7 pr-2 py-1.5 text-xs text-gray-700 outline-none focus:ring-2 focus:ring-emerald-500/20 appearance-none cursor-pointer transition-all hover:border-emerald-300 font-mono"
                    disabled={loadingContext}
                    value={usuario.selectedPeriodo || ''}
                    onChange={(e) => {
                      const val = e.target.value
                      handleSessionUpdate({ periodo: val })
                    }}
                  >
                    {periodos.length > 0 ? periodos.map(p => (
                      <option key={p.id} value={p.nombre}>{p.nombre}</option>
                    )) : (
                      <option value="">Cargando...</option>
                    )}
                  </select>
                  <FiChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400 pointer-events-none" />
                </div>
             </div>
           </div>
        </div>
      )}

      {pathname.startsWith('/crm') && usuario?.empresaNombre && (
        <div className="px-6 py-4 bg-blue-50/50 border-b space-y-3 animate-in slide-in-from-left duration-300">
          <div className="space-y-0.5">
            <p className="text-[9px] font-bold text-blue-600 uppercase tracking-widest">Modulo</p>
            <p className="text-sm font-bold text-gray-800 truncate">CRM Campanas</p>
          </div>
          <div className="space-y-0.5">
            <p className="text-[9px] font-bold text-blue-600 uppercase tracking-widest">Empresa activa</p>
            <p className="text-sm font-bold text-gray-800 truncate">{usuario.empresaNombre}</p>
          </div>
          {!usuario?.crmOnly ? (
            <Link
              href="/empresas"
              className="inline-flex items-center gap-2 rounded-lg bg-white border border-blue-100 px-3 py-2 text-xs font-bold text-blue-700 hover:bg-blue-50 transition-colors"
            >
              <FiBriefcase className="h-3.5 w-3.5" />
              Cambiar empresa
            </Link>
          ) : null}
        </div>
      )}

      <div className="flex-1 overflow-y-auto overflow-x-hidden flex flex-col px-3 py-4 custom-scrollbar">
        <nav className="space-y-1">
          {items.map((section, idx) => (
            <div key={idx} className="space-y-1">
              {section.title && (
                <div className="px-3 py-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-4 flex-shrink-0">
                  {section.title}
                </div>
              )}
                {section.items.map((item: any) => {
                const Icon = item.icon
                const hasSubItems = item.subItems && item.subItems.length > 0
                const isOpen = openMenus[item.label]
                const isActive = item.href ? pathname === item.href : item.subItems?.some((s: any) => pathname === s.href)
                
                if (hasSubItems) {
                   return (
                    <div key={item.label} className="space-y-1">
                      <button
                        onClick={() => toggleMenu(item.label)}
                        className={cn(
                          "flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-sm font-semibold transition-all group",
                          isActive ? "text-emerald-700 bg-emerald-50" : "text-gray-500 hover:bg-gray-50 hover:text-gray-900"
                        )}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          <Icon className={cn("h-5 w-5 shrink-0", isActive ? "text-emerald-600" : "text-gray-400 group-hover:text-emerald-500")} />
                          <span className="truncate">{item.label}</span>
                        </div>
                        <div className="flex items-center gap-2">
                           {item.badge && (
                            <span className="text-[8px] bg-red-100 text-red-600 px-1.5 py-0.5 rounded-full font-black uppercase">
                              {item.badge}
                            </span>
                          )}
                          {isOpen ? <FiChevronDown className="h-3 w-3 shrink-0" /> : <FiChevronRight className="h-3 w-3 shrink-0" />}
                        </div>
                      </button>
                      
                      {isOpen && (
                        <div className="ml-5 space-y-1 border-l-2 border-emerald-100 pl-4 animate-in slide-in-from-top-1 duration-200 mt-1 mb-2">
                          {item.subItems.map((sub: any) => (
                            <Link
                              key={sub.href + sub.label}
                              href={sub.href}
                              className={cn(
                                "flex items-center justify-between rounded-lg px-3 py-2 text-xs font-semibold transition-all relative",
                                pathname === sub.href 
                                  ? "text-emerald-700 bg-emerald-50/50 before:absolute before:left-[-17px] before:top-1/2 before:-translate-y-1/2 before:w-1 before:h-3 before:bg-emerald-500 before:rounded-full" 
                                  : "text-gray-500 hover:text-gray-900 hover:bg-gray-50/80"
                              )}
                            >
                              <span className="truncate">{sub.label}</span>
                              {sub.badge && (
                                <span className="text-[7px] bg-emerald-500 text-white px-1.5 py-0.5 rounded font-black uppercase">
                                  {sub.badge}
                                </span>
                              )}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  )
                }

                return (
                  <Link
                    key={item.href + item.label}
                    href={item.href}
                    prefetch={true}
                    className={cn(
                      "flex items-center justify-between rounded-xl px-3 py-2.5 text-sm font-bold transition-all group",
                      isActive 
                        ? "bg-emerald-600 text-white shadow-md shadow-emerald-200" 
                        : "text-gray-600 hover:bg-gray-50"
                    )}
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      <Icon className={cn("h-5 w-5 shrink-0", isActive ? "text-white" : "text-gray-400 group-hover:text-emerald-500")} />
                      <span className="truncate">{item.label}</span>
                    </div>
                    {item.badge && (
                      <span className={cn(
                        "text-[9px] font-black px-1.5 py-0.5 rounded uppercase tracking-tighter shadow-sm shrink-0",
                        isActive ? "bg-white/20 text-white" : "bg-emerald-100 text-emerald-700"
                      )}>
                        {item.badge}
                      </span>
                    )}
                  </Link>
                )
              })}
            </div>
          ))}
        </nav>

        <div className="space-y-1 border-t pt-4 mt-auto">
          <button
            onClick={handleLogout}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors"
          >
            <FiLogOut className="h-5 w-5" />
            Cerrar Sesión
          </button>
        </div>
      </div>
      <style jsx global>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #cbd5e1;
        }
      `}</style>
    </aside>
  )
}
